import { Date as V3Date, DateProps } from '@stadionhq-v3/base-ui';
import classnames from 'classnames';
import styles from './date.module.scss';

export const Date = ({ classNames, ...props }: DateProps) => {
  const classes = classnames(
    [
      styles.date,
      {
        [`${styles.onDark}`]: props.onDark,
      },
    ],
    classNames
  );

  return <V3Date classNames={[classes]} {...props} />;
};
